import { useRouteError } from 'react-router-dom'
import { useEffect } from 'react'
import { captureException } from '@sentry/react'
import ErrorPage from '../pages/ErrorPage'

export default function SentryRouteErrorFallback() {
  const routeError = useRouteError()

  useEffect(() => {
    captureException(routeError, { level: 'error' })
  }, [routeError])

  return <ErrorPage />
}
